// Tiny helpers for the URL ↔ partyCode mapping.
//
// The URL is the source of truth for which room the user is in:
//   /         → root; the IdentityProvider may redirect to the last-known room
//   /glob     → global room
//   /p/:CODE  → 4-letter party room (case-normalized to uppercase)
//   anything else → "not found" — handled by the route catch-all
//
// localStorage.partyCode is preserved only as "last known room" memory for the
// `/` → `/p/${lastCode}` redirect on next session. The URL drives state.

export const GLOB = 'GLOB';

export const PARTY_CODE_PATTERN = /^[A-Z]{4}$/;

const PARTY_PATH_RE = /^\/p\/([^/]+)\/?$/;

/**
 * Read a partyCode from a pathname. Returns either:
 *   - 'GLOB' for /, /glob (and any other trivially-rooted URL)
 *   - the upper-cased code from /p/:CODE when it matches the 4-letter pattern
 *   - null when /p/:CODE param doesn't look like a code (caller should show
 *     PartyNotFound rather than silently coercing)
 */
export function partyCodeFromPath(pathname) {
  if (!pathname || pathname === '/' || pathname === '/glob') return GLOB;
  const m = pathname.match(PARTY_PATH_RE);
  if (!m) return GLOB; // unknown route — fall back to GLOB
  const raw = String(m[1]).toUpperCase();
  if (!PARTY_CODE_PATTERN.test(raw)) return null;
  return raw;
}

/**
 * Inverse: produce the canonical URL path for a partyCode.
 */
export function pathForPartyCode(code) {
  if (!code || code === GLOB) return '/glob';
  return `/p/${String(code).toUpperCase()}`;
}
